import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import * as localforage from 'localforage';
import * as AES from 'crypto-js/aes';
import * as SHA256 from 'crypto-js/sha256';

@Component({
  selector: 'asv-singin-as',
  template: `
    <div class="container">
      <div class="row">
        <div class="content-box form-width section-top login">
          <form class="mx-auto" [formGroup]="signinForm">
            <h2 class="text-center">{{ 'sign.signin_as.title' | translate }}</h2>
            <h3 class="text-center">{{ 'sign.signin_as.description' | translate }}</h3>
            <div class="form-group">
              <label for="field_email">Zalogowany jako<br/><b>Jan Kowalski</b></label>
            </div>
            <div class="form-group">
              <label for="field_password">{{ 'forms.fields.password' | translate }}</label>
              <input type="password"
                     class="form-control"
                     id="field_password"
                     formControlName="password"
                     placeholder="{{ 'forms.fields.password' | translate }}">
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-success btn-block" (click)="signin()">{{ 'buttons.signin' | translate }}</button>
              <button type="button" class="btn btn-success btn-block" (click)="chagneAccount()">
                {{ 'buttons.change_account' | translate }}
              </button>
              <button type="button" class="btn btn-secondary btn-block" (click)="forgotPassword()">
                {{ 'buttons.forgot_password' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  `,
  styles: [`
    :host {
      width: 100%;
    }
  `]
})
export class SinginAsComponent implements OnInit {
  public signinForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    this.makeForm();
      const user = localforage.getItem('user').then(indexedUser => {
      if (indexedUser) {
          const decrypted = CryptoJS.AES.decrypt(indexedUser, 'secret');
          const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
          const userData = JSON.parse(plaintext);
      }
    });
  }

  public makeForm() {
    this.signinForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  public signin() {
    this.router.navigateByUrl('/sign/split-accounts');
  }

  public chagneAccount() {
    this.router.navigateByUrl('/signin');
  }

  public forgotPassword() {
    this.router.navigateByUrl('/forgot-password');
  }

}
